// extracted by mini-css-extract-plugin
export default {"Beneficiary":"Beneficiarios_Beneficiary__bLxfX","Parentage":"Beneficiarios_Parentage__f69rt","BeneficiaryBtn":"Beneficiarios_BeneficiaryBtn__6rqly"};